<template>
  <v-snackbar dark v-model="snackbar.show" :color="snackbar.color" top>
    {{ snackbar.text }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbar.show = false">{{
        $t("generic.close")
      }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { defineComponent, reactive } from "@vue/composition-api";

export default defineComponent({
  setup(props, vm) {
    const snackbar = reactive({
      show: false,
      text: "",
      color: "success",
    });

    vm.root.$on("snackbar", (text = "", color = "success") => {
      snackbar.show = true;
      snackbar.text = text;
      snackbar.color = color;
    });

    return {
      snackbar,
    };
  },
});
</script>
